import React from 'react';

import templateRemovalConfirmationImgPath from 'assets/svgs/check-dark-gray.svg';
import { CloseButton } from 'ui-kit';

interface TemplateToastContentProps {
  documentName: string;
  isCreatingTemplate: boolean;
  onClose: () => void;
}

const TemplateToastContent: React.FC<TemplateToastContentProps> = ({
  documentName,
  isCreatingTemplate,
  onClose,
}) => (
  <div style={{ display: 'flex', flexDirection: 'row' }}>
    <img
      className="mr-6 rounded-lg bg-success-default"
      src={templateRemovalConfirmationImgPath}
      alt="template removal confirmation check"
      width={56}
      height={56}
    />
    <div>
      <div
        style={{
          fontSize: '20px',
          fontWeight: 500,
          marginBottom: '8px',
        }}
      >
        Template {isCreatingTemplate ? 'Created' : 'Removed'}
      </div>
      <div>
        <b>{documentName}</b> has been {isCreatingTemplate ? 'created' : 'removed'} as a template.
      </div>
    </div>
    <CloseButton onClick={onClose} />
  </div>
);

export default TemplateToastContent;
